import { isCellphone } from "./device";

export function getBaseUrl(entity, entityId, extension) {
  return `${process.env.REACT_APP_CNH_POP_OPEN_GRAPH_URL}`;
}

export function getSubscriptionPageShortUrl(entity, entityId, extension) {
  return `${process.env.REACT_APP_APP_SUBSCRIPTION_PAGE_SHORT_URL}`;
}

export function getOpenGraphDescription(entity, entityId, extension) {
  return `${process.env.REACT_APP_CNH_POP_OPEN_GRAPH_DESCRIPTION}`;
}


export function getLogoUrl(entity, entityId, extension) {
  return `${process.env.REACT_APP_SERVER_BASE_PATH}/assets/images/logos/${entity}/${entityId}.${extension}`;
}

export function getDefaultLogoUrl(entity) {
  const file = isCellphone() ? 'default-mobile.png' : 'default.png';
  return `${process.env.REACT_APP_SERVER_BASE_PATH}/assets/images/logos/${entity}/${file}`;
}

export function getVideoUrl(entity, entityId, extension) {
  return `${process.env.REACT_APP_SERVER_BASE_PATH}/assets/videos/${entity}/${entityId}.${extension}`;
}

export function getVoucherUrl(registrationId, extension) {
  return `${process.env.REACT_APP_SERVER_BASE_PATH}/assets/images/vouchers/${registrationId}.${extension}`;
}

export function getVoucherPrintUrl(registrationId, extension) {
  return `${process.env.REACT_APP_SERVER_BASE_PATH}/assets/images/vouchers/index.html?voucher=${registrationId}.${extension}`;
}
